import { render } from "./App.vue?vue&type=template&id=43f8a59e"
const script = {}

import exportComponent from "/codebuild/output/src1350238635/src/wfyt-leaderboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__